import { object, string } from "yup";

export const rejectWithdrawalSchema = object({
    admin_note: string().max(255, "Máximo de 255 caracteres").nullable(),
});
